import { PIXI } from '@colonist/pixi';
import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { GameFont } from '../../GameFont.ts';
import { MovingSectionView } from '../../ui_canvas_engine/MovingSectionView.ts';
import { TextTruncatedView } from '../../ui_canvas_engine/TextTruncatedView.ts';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIGameGoToPointFadeAnimation } from '../../ui_canvas_engine/animation/UIGameGoToPointFadeAnimation.ts';
import { UIGameAnimationBase } from '../../ui_canvas_engine/animation/UIGameAnimationBase.ts';
import { GameColor } from '@colonist/ui-game';
export class UIGameFloatingVictoryPointsView extends MovingSectionView {
    drawFloatingVPView(texture, text) {
        this.drawBackground(texture);
        this.drawText(text, GameFont.Size.Normal);
        this.drawTrophy();
    }
    drawBackground(texture) {
        var _this_ribbonView;
        (_this_ribbonView = this.ribbonView) === null || _this_ribbonView === void 0 ? void 0 : _this_ribbonView.destroy();
        this.ribbonView = new SpriteView(0, 0, this.width, this.height, this, texture);
        this.ribbonView.centerXInParent();
    }
    drawText(text, fontSize) {
        var _this_textView;
        const textW = this.width * 0.6;
        (_this_textView = this.textView) === null || _this_textView === void 0 ? void 0 : _this_textView.destroy();
        this.textView = new TextTruncatedView(text, 0, 0, textW, this.height, this);
        this.textView.changeStyle({
            fontWeight: GameFont.Weight.Bold,
            fontSize: GameFont.getResponsiveSize(fontSize),
            fill: GameColor.Color.Gray0
        }, false);
        this.textView.centerXInParent();
        this.textView.centerYInParent();
    }
    drawTrophy() {
        var _this_trophyView;
        (_this_trophyView = this.trophyView) === null || _this_trophyView === void 0 ? void 0 : _this_trophyView.destroy();
        const trophyViewH = this.height * 0.7;
        const trophyTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy);
        const trophyViewW = trophyViewH * trophyTexture.width / trophyTexture.height;
        this.textView.x = (this.width - this.textView.width - this.uiGameManager.canvasController.margin / 2 - trophyViewW) / 2;
        const trophyViewX = this.textView.x + this.textView.width + this.uiGameManager.canvasController.margin / 2;
        const trophyViewY = this.height / 2 - trophyViewH / 2 - this.uiGameManager.canvasController.margin / 3;
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy);
        this.trophyView = new SpriteView(trophyViewX, trophyViewY, trophyViewW, trophyViewH, this, texture);
        this.trophyView.cacheAsBitmap = true;
    }
    setVerticalAnimation(distanceY, velocityY, fadeSpeed, howToWinAnimation = false, delayBetweenAnimations = 2000) {
        const firstStopPoint = new PIXI.Point(this.x, this.y - distanceY);
        const secondStopPoint = new PIXI.Point(this.x, this.y - distanceY * 2);
        const firstStepAnimation = new UIGameGoToPointFadeAnimation(this, firstStopPoint, velocityY, {
            initialAlpha: 0,
            fadeSpeed: fadeSpeed,
            completionPercentageToStartFade: 0,
            isFadeIn: true
        });
        const secondStepAnimation = new UIGameGoToPointFadeAnimation(this, secondStopPoint, velocityY, {
            initialAlpha: 1,
            fadeSpeed: fadeSpeed,
            completionPercentageToStartFade: 0,
            isFadeIn: false
        });
        secondStepAnimation.setOnStopCallback(()=>this.parent.removeChild(this));
        UIGameAnimationBase.composeAnimations([
            firstStepAnimation,
            secondStepAnimation
        ], delayBetweenAnimations).start();
    }
    constructor(uiGameManager, x, y, w, h, container, text, texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ribbon_large)){
        super(x, y, w, h, container);
        this.uiGameManager = uiGameManager;
        this.drawFloatingVPView(texture, text);
        this.zIndex = this.uiGameManager.mapController.mapView.layers.mapCityWall;
        this.eventMode = 'none';
    }
}
